import { useState } from "react";
import { COIN_LOGOS, COIN_COLORS } from "@/lib/format";

export default function CoinIcon({ symbol, size = 32, className = "" }) {
  const [err, setErr] = useState(false);
  const sym = (symbol || "").toUpperCase();
  const src = COIN_LOGOS[sym];
  if (err || !src) {
    return (
      <span
        className={`inline-flex items-center justify-center rounded-full text-white font-bold ${className}`}
        style={{ width: size, height: size, background: COIN_COLORS[sym] || "#64748B", fontSize: size * 0.36 }}
      >
        {sym.slice(0, 3)}
      </span>
    );
  }
  return (
    <img
      src={src}
      alt={sym}
      width={size}
      height={size}
      onError={() => setErr(true)}
      className={`inline-block ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
